/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Analyze_Job_DescriptionInputs */

const en_negotiation_analyze_job_description = /** @type {(inputs: Negotiation_Analyze_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-detect relevant negotiation scenarios from a job description`)
};

const de_negotiation_analyze_job_description = /** @type {(inputs: Negotiation_Analyze_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-detect relevant negotiation scenarios from a job description`)
};

const fr_negotiation_analyze_job_description = /** @type {(inputs: Negotiation_Analyze_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-detect relevant negotiation scenarios from a job description`)
};

const es_negotiation_analyze_job_description = /** @type {(inputs: Negotiation_Analyze_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-detect relevant negotiation scenarios from a job description`)
};

const it_negotiation_analyze_job_description = /** @type {(inputs: Negotiation_Analyze_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-detect relevant negotiation scenarios from a job description`)
};

const nl_negotiation_analyze_job_description = /** @type {(inputs: Negotiation_Analyze_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-detect relevant negotiation scenarios from a job description`)
};

const pl_negotiation_analyze_job_description = /** @type {(inputs: Negotiation_Analyze_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-detect relevant negotiation scenarios from a job description`)
};

const fi_negotiation_analyze_job_description = /** @type {(inputs: Negotiation_Analyze_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-detect relevant negotiation scenarios from a job description`)
};

const da_negotiation_analyze_job_description = /** @type {(inputs: Negotiation_Analyze_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-detect relevant negotiation scenarios from a job description`)
};

const sv_negotiation_analyze_job_description = /** @type {(inputs: Negotiation_Analyze_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-detect relevant negotiation scenarios from a job description`)
};

/**
* | output |
* | --- |
* | "Auto-detect relevant negotiation scenarios from a job description" |
*
* @param {Negotiation_Analyze_Job_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_analyze_job_description = /** @type {((inputs?: Negotiation_Analyze_Job_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Analyze_Job_DescriptionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_analyze_job_description(inputs)
	if (locale === "fr") return fr_negotiation_analyze_job_description(inputs)
	if (locale === "es") return es_negotiation_analyze_job_description(inputs)
	if (locale === "it") return it_negotiation_analyze_job_description(inputs)
	if (locale === "nl") return nl_negotiation_analyze_job_description(inputs)
	if (locale === "pl") return pl_negotiation_analyze_job_description(inputs)
	if (locale === "fi") return fi_negotiation_analyze_job_description(inputs)
	if (locale === "da") return da_negotiation_analyze_job_description(inputs)
	if (locale === "sv") return sv_negotiation_analyze_job_description(inputs)
	return en_negotiation_analyze_job_description(inputs)
});